import React, { useEffect, useState } from "react";
import { searchInspectionCycles } from "../../helpers/backend_helper";
import EngagementList from "./EngagementList";

export default function EngagementWorkspacePage() {
  const [inspectionCycles, setInspectionCycles] = useState([]);

  useEffect(() => {
    let current = true;
    searchInspectionCycles({ projectTypeId: 0, projectStatusId: 0 })
      .then((response) => {
        if (current && response?.status)
          setInspectionCycles(response.data || []);
      })
      .catch(() => {
        if (current) setInspectionCycles([]);
      });
    return () => {
      current = false;
    };
  }, []);

  return (
    <EngagementList
      showInspectionCycleColumn
      inspectionCycles={inspectionCycles}
    />
  );
}
